// src/modules/app-views/account/pages/Init/actions/actionButton.js
import {
  DeleteOutlined,
  LockOutlined,
  MailOutlined,
  MobileOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { openModal } from 'components/core/GenericModal';
import app from 'configs/appResolver';
import ChangePasswordModal from '../modals/ChangePasswordModal';
import ChangePhoneModal from '../modals/ChangePhoneModal';
import ChangeEmailModal from '../modals/ChangeEmailModal';
import RemoveAccountModal from '../modals/RemoveAccountModal';

const initActionButton = () => {
  const canRemoveAccount = app?.PRESET?.MULTI_SUBSCRIPTIONS !== false;

  return {
    action: 'save',
    hideButton: false,
    label: 'save',
    tooltip: 'save_document',
    icon: null,
    type: 'primary',
    disabled: false,

    // Primary button handler - uses moduleContext.formContext pattern
    onClick: ({ moduleContext }) => {
      moduleContext?.formContext?.submitForm?.();
    },

    // Dropdown configuration
    dropdownIcon: <SettingOutlined />,
    dropdownTooltip: 'more_options',
    dropdownDisabled: false,
    dropdownItems: [
      {
        key: 'changeMyPassword',
        label: 'change_password',
        icon: <LockOutlined />,
        onClick: async context => await openModal(ChangePasswordModal, { context }),
      },
      {
        key: 'changeMyPhone',
        label: 'change_phone',
        icon: <MobileOutlined />,
        onClick: async context => await openModal(ChangePhoneModal, { context }),
      },
      {
        key: 'changeMyEmail',
        label: 'change_email',
        icon: <MailOutlined />,
        onClick: async context => await openModal(ChangeEmailModal, { context }),
      },
      ...(canRemoveAccount
        ? [
            'divider',
            {
              key: 'removeMyProfile',
              label: 'remove_account',
              icon: <DeleteOutlined />,
              danger: true,
              onClick: async context => await openModal(RemoveAccountModal, { context }),
            },
          ]
        : []),
    ],
  };
};

export default initActionButton;
